<template>
  <div class="animated fadeIn">
    <CModal v-model:visible="showModal"
      :size="sizeModal"
      @close="() => $emit('cancelled',false)">
      <!--   :color="colorModal" -->

      <!-- class="bg-danger text-light" -->
      <CModalHeader class="text-light" :class="`bg-${colorModal}`">
        <CModalTitle>{{$t('GLOBAL.EXPEDIENTES.MODAL.expedientes')}}</CModalTitle>
      </CModalHeader>

      <CModalBody class="text-center d-block">
        <template v-if="content">
          <h3> {{$t('GLOBAL.EXPEDIENTES.MODAL.enviar_expediente')}}</h3>
          <p>{{$t('GLOBAL.EXPEDIENTES.MODAL.deseas_enviar_expediente_a')}}{{ companyName }} {{$t('GLOBAL.EXPEDIENTES.MODAL.para_su_valoracion')}}</p>
          <p>{{$t('GLOBAL.EXPEDIENTES.MODAL.el_coste_son')}}<strong>{{ expediente?.coste || '0' }}€</strong> {{$t('GLOBAL.EXPEDIENTES.MODAL.y_su_saldo_es_de')}} <strong> {{ centro?.saldo || '0' }}€</strong>.</p>
          <!-- <p>El coste son <strong>9,5€</strong> y su saldo es de <strong>100€</strong>.</p> -->
        </template>
  
        <slot></slot>
      </CModalBody>

       <CModalFooter>
        <CButton @click="$emit('cancelled',false)" color="link" class="text-dark">{{$t('GLOBAL.BTN.cancelar')}}</CButton>
        <CButton @click="$emit('confirm')" :color="colorModal">
          {{$t('GLOBAL.BTN.enviar')}}
        </CButton>
       </CModalFooter>

    </CModal>
  </div>
</template>

<script>
import { COMPANY_DATA } from '@/config';

export default {
  name: 'ConfirmarModal',
  props: {
    title: { type: String, default: 'Eliminar' },
    show: { type: Boolean, default: false, required: true },
    content: { type: Boolean, default: true },
    colorModal: {type: String, default: 'primary' }, // info, warning, primary
    sizeModal: {type: String, default: 'lg' }, // size="lg" 
    expediente: { type: Object, default: null },
    centro: { type: Object, default: null },
  },
  computed: {
    showModal() {
      return this.show;
    },
    companyName() {
      return COMPANY_DATA.company_name
    }
  },
}
</script>